import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import $ from "jquery";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import ActionButton from "../common/button/actionbutton.component.jsx";
import Checkbox from "../common/checkbox/checkbox.component.jsx";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import StandardList from '../common/listing/list.component.jsx'
import LabelUnitOfMeasure from "../common/unit-of-measure/label.component.jsx";
import Integrations from "../integration/Integrations.jsx";
import * as IntegrationConstants from "../integration/IntegrationConstants.jsx"
import GlobalHelper from "../common/GlobalHelper.jsx";
import { FeaturePurchaseOrderTracking } from '../state/integration/IntegrationFeatureKeys';
import {PRODUCT_TYPE} from "../state/product/Types"
const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    "order.new_external_purchase_order_modal.error.supplier_required": {
        id: 'order.new_external_purchase_order_modal.error.supplier_required',
        defaultMessage: 'You must select at least one line item that has a supplier',
    },
    "order.new_external_purchase_order_modal.error.item_required": {
        id: 'order.new_external_purchase_order_modal.error.item_required',
        defaultMessage: 'You must select at least one line item',
    },
});
class NewExternalPurchaseOrderModal extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'external-purchase-order-creation-modal-' + uuidv4(),
            orderId: this.props.orderId,
            itemsListToOrder: [],
            checkAll: true,
            groups: this.props.groups,
            errorMessages: [],
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.onItemChecked = this.onItemChecked.bind(this)
        this.onItemInputChange = this.onItemInputChange.bind(this)
        this.onCheckAll = this.onCheckAll.bind(this)
        this.getIntegrationKey = this.getIntegrationKey.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        this.refreshSearch()
    }

    closeModal(e) {
        if (e) {
            e.preventDefault()
        }
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    allowOrder() {
        return this.state.errorMessages.length === 0
    }

    hasIntegrationThatRequiresASupplier() {
        return [
            IntegrationConstants.integrationKeyVend,
            IntegrationConstants.integrationKeyQuickbooks,
        ].includes(this.getIntegrationKey())
    }

    validateItems() {
        let errorMessages = []
        const itemsToOrderWithPositiveMeasure = this.state.itemsListToOrder.filter(item =>
            item.checked && item.attributes.measureToRequest > 0)

        const hasAtLeastOneProductToOrder = itemsToOrderWithPositiveMeasure.length > 0
        if (!hasAtLeastOneProductToOrder) {
            errorMessages.push(this.props.intl.formatMessage(messages["order.new_external_purchase_order_modal.error.item_required"]))
            this.setState({
                errorMessages: errorMessages,
            })
            return errorMessages
        }

        if (this.hasIntegrationThatRequiresASupplier()) {
            const hasAtLeastOneProductWithASupplier = itemsToOrderWithPositiveMeasure.filter(item => item.attributes.itemObject.attributes.defaultVendorLabelTitle).length > 0
            if (!hasAtLeastOneProductWithASupplier) {
                errorMessages.push(this.props.intl.formatMessage(messages["order.new_external_purchase_order_modal.error.supplier_required"]))
            }
        }

        this.setState({
            errorMessages: errorMessages,
        })
    }

    submit(e) {
        e.preventDefault()
        const itemsListToOrder = this.state.itemsListToOrder.filter(item => parseFloat(item.attributes.measureToRequest) > 0)
        const data = {
            integrationKey: this.getIntegrationKey(),
            orderId: this.state.orderId,
            lines: itemsListToOrder.map(item => {
                return {
                    referenceRowId: item.id,
                    measure: String(item.attributes.measureToRequest),
                }
            }),
        }

        AppContext.getApiClient().post(`/orders/external-purchase-orders`, data).then(po => {
            if (po.error) {
                this.setState({ loading: false })
                return
            }

            window.open(Integrations.getExternalPurchaseOrderUrl(po), '_blank')
            this.closeModal()
        })
    }

    getIntegrationKey() {
        return GlobalHelper.getFirstIntegrationKeyFoundWithEnabledFeature(FeaturePurchaseOrderTracking)
    }

    async refreshSearch() {
        this.setState({
            loading: true
        })
        const res = await AppContext.getApiClient().get(`/orders/${this.state.orderId}`)

        const itemsListToOrder = res.attributes.items.filter(item => {
            const product = item.attributes.itemObject
            if (!product.attributes.externalLinks || product.attributes.externalLinks.length === 0) {
                return false
            }
            const link = GlobalHelper.getObjectExternalLink(product, this.getIntegrationKey())
            const isNonInventory = item.attributes.itemObject.attributes.isNonInventory
            return link && !isNonInventory
        }).map(item => {
            item.checked = true
            const measured = parseFloat(item.attributes.inventoryRequestedMeasure)
            const received = parseFloat(item.attributes.inventoryReceivedMeasure)
            item.attributes.measureToRequest = measured - received
            if (item.attributes.externalPurchaseOrder || item.attributes.measure <= 0) {
                item.disabled = true
                item.checked = false
                item.attributes.measureToRequest = 0
            }
            item.attributes.maxMeasureRequested = item.attributes.measureToRequest
            return item
        })

        this.setState({
            itemsListToOrder,
            loading: false,
        }, () => {
            this.validateItems()
        })
    }

    onCheckAll(isChecked) {
        this.setState({
            checkAll: isChecked,
            itemsListToOrder: this.state.itemsListToOrder.map(item => {
                item.checked = !item.disabled ? isChecked : false
                item.attributes.measureToRequest = isChecked ? item.attributes.maxMeasureRequested : 0
                return item
            })
        }, () => {
            this.validateItems()
        })
    }

    onItemChecked(item, isChecked) {
        item.checked = isChecked
        item.attributes.measureToRequest =
            isChecked ? item.attributes.maxMeasureRequested : 0

        this.setState({
            itemsListToOrder: [...this.state.itemsListToOrder]
        }, () => {
            this.validateItems()
        })
    }

    onItemInputChange(item, val) {
        if (parseFloat(val) > item.attributes.maxMeasureRequested)
            val = item.attributes.maxMeasureRequested
        else if (parseFloat(val) < 1)
            val = 1

        item.attributes.measureToRequest = val
        this.setState({
            itemsListToOrder: [...this.state.itemsListToOrder]
        }, () => {
            this.validateItems()
        })
    }


    headers() {
        return [
            <FormattedMessage
                id="order.external_purchase_order_modal.product_name_label"
                defaultMessage="Product name"
            />,
            this.hasIntegrationThatRequiresASupplier() && <FormattedMessage
                id="order.external_purchase_order_modal.supplier_label"
                defaultMessage="Supplier"
            />,
            <FormattedMessage
                id="order.external_purchase_order_modal.quantity_requested_label"
                defaultMessage="Quantity requested"
            />,
            <FormattedMessage
                id="order.external_purchase_order_modal.quantity_already_requested_label"
                defaultMessage="Already ordered"
            />,
            <FormattedMessage
                id="order.external_purchase_order_modal.quantity_to_be_order_label"
                defaultMessage="To be order"
            />,
            <Checkbox id={'check-all'}
                checked={this.state.checkAll}
                onChange={isChecked => this.onCheckAll(isChecked)} />,
        ]
    }

    row(item) {
        return [
            <div>
                {item.attributes.activeTitle}
            </div>,
            this.hasIntegrationThatRequiresASupplier() && <div>
                {item.attributes.itemObject.attributes.defaultVendorLabelTitle}
            </div>,
            <div className="text-center">
                {item.attributes.inventoryRequestedMeasure}
            </div>,
            <div className="text-center">
                {item.attributes.externalPurchaseOrder ? item.attributes.inventoryRequestedMeasure : '0'}
            </div>,
            <div className="input-group m-1">
                <LabelUnitOfMeasure
                    value={item.attributes.measureToRequest}
                    unit={item.attributes.unitOfMeasure}
                    format={'short'}
                />
            </div>,
            !item.disabled ? <Checkbox id={'returned-item-' + item.id}
                checked={item.checked}
                onChange={isChecked => this.onItemChecked(item, isChecked)}
                style={{ top: 0 }} /> : ''
        ]
    }

    renderCreatePurchaseOrderButton() {
        if (!this.getIntegrationKey()) {
            return <></>
        }

        let integrationLogoSrc = Integrations.getIntegrationLogoImagePath(this.getIntegrationKey(), true)

        return (
            <ActionButton
                type="button"
                className="btn btn-success"
                onClick={this.submit}
                disabled={!this.allowOrder()}
                isLoading={this.state.loading}
            >
                <img src={integrationLogoSrc} className={'mr-2'} style={{ width: '1rem' }} />
                <FormattedMessage
                    id="order.external_purchase_order_modal.create_btn"
                    defaultMessage="Create purchase order"
                />
            </ActionButton>
        )
    }


    render() {
        const itemsList = this.state.itemsListToOrder
            .filter(item => item.attributes.itemObject?.attributes?.type !== PRODUCT_TYPE.BUNDLE)
            .sort((item1, item2) => GlobalHelper.compareItemsByGroupAndRank(item1, item2, this.state.groups))
            .map(item => this.row(item))

        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="purchaseOrderModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0 d-flex align-items-center"
                            id="purchaseOrderModalTitle">
                            <FormattedMessage
                                id="order.external_purchase_order_modal.title"
                                defaultMessage="New Purchase Order"
                            />
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            {!this.state.loading ? <StandardList
                                className="row"
                                headers={this.headers()}
                                rows={itemsList}
                                smallLine={true}
                            /> : <LoadingSpinner />}
                        </div>
                    </div>
                    <div className="modal-footer">

                        {
                            this.state.errorMessages.map(errMessage => {
                                return <div className="text-danger w-100 d-flex justify-content-end">{errMessage}</div>
                            })
                        }

                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="order.external_purchase_order_modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                        {this.renderCreatePurchaseOrderButton()}
                    </div>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(NewExternalPurchaseOrderModal)



// WEBPACK FOOTER //
// ./src/order/newexternalpurchaseordermodal.component.jsx